module.exports = __webpack_public_path__ + "img/project.5d01e225.jpg";